export default "__VITE_ASSET__BFVLxqKg__"